module.exports = __webpack_public_path__ + "img/pleat_bottom_width.9e9d6fce.png";